
export default {
  name: 'DefaultRoute',

  // Nuxt.js layout hook to determine layout dynamically
  layout(context) {
    let l = '';
    if (context.store.state.pageData.globalType === 'ABOUTUS') {
      l = 'two_column_with_left_sidebar'; // Layout for CMS pages
    } else {
      l = 'default'; // Default layout for other pages
    }
    return l;
  },

  data() {
    return {
      pageTypes: {
        PLP: 'ProductListing',
        PARENT_CATEGORY: 'CategoryPage',
        PDP: 'ProductPage',
        PROMOPAGE: 'ProductListing',
        SALES_LANDING: 'SalesLandingPage',
        ABOUTUS: 'AboutUs',
        CMS: 'HelpCenterPage',
        CONTACTUS: 'HelpCenterPage',
        TRACK_ORDER_FORM: 'TrackMyOrderPage',
      },
    };
  },

  computed: {
    // Get the current page type from the Vuex store
    pageType() {
      return this.$store.state.pageData.globalType;
    },

    // Get the page component name based on the page type
    pageName() {
      return this.pageTypes[this.pageType] || '';
    },
  },

  watch: {
    // Watch for changes in the pageType to dynamically update the layout
    pageType(newValue, oldValue) {
      if (newValue !== oldValue) {
        const newLayout = this.$options.layout(this.$nuxt.context); // Call layout directly
        if (this.$nuxt.$options.layout !== newLayout) {
          this.$nuxt.setLayout(newLayout); // Update the layout dynamically
        }
      }
    },
  },

  mounted() {
    // Set the correct layout when the component is mounted
    const currentLayout = this.$options.layout(this.$nuxt.context); // Call layout directly
    if (this.$nuxt.$options.layout !== currentLayout) {
      this.$nuxt.setLayout(currentLayout); // Update layout when mounting
    }
  },
};
